import styled from "styled-components";
import Logo from "../Logo/Logo";
import Icon from "../Icon/Icon";
import Box from "../Box/Box";
import { position, LayoutProps, PositionProps } from "styled-system";

export interface MarkerProps extends PositionProps {
  /**
   marker color
  */
  color?: string;
  /**
   marker width
  */
  width?: LayoutProps["width"];
  /**
   marker height
  */
  height?: LayoutProps["height"];
}

const StyledIcon = styled(Icon)`
  position: absolute;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  z-index: 1;
`;

const BCALogo = styled(Logo)`
  width: 75%;
  height: 22%;
  position: absolute;
  z-index: 2;
  top: 25%;
`;

const MarkerContainer = styled(Box)`
  position: relative;
  ${position}
`;

const MapMarker = ({
  color = "primary-navy-blue",
  height = "46px",
  width = `calc(0.75 * ${height})`,
  ...props
}: MarkerProps) => (
  <MarkerContainer
    width={width}
    height={height}
    display="flex"
    justifyContent="center"
    {...props}
  >
    <BCALogo data-testid="bca-logo" />
    <StyledIcon
      name="map-marker"
      width="100%"
      height="100%"
      weight="solid"
      color={color}
    />
  </MarkerContainer>
);

export default MapMarker;
